import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import katex from "katex";
import { bindPropStore } from "../bindProps";
import { bool, text } from "../helpers";

var root = $.from_html(`<div class="slex-formula"></div>`);

export default function Formula($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	const tex = $.derived(() => text($.get(p).tex ?? $.get(p).formula ?? $.get(p).value));

	const displayMode = $.derived(() => $.get(p).displayMode === undefined && $.get(p).display === undefined && $.get(p).block === undefined
		? true
		: bool($.get(p).displayMode ?? $.get(p).display ?? $.get(p).block));

	const rendered = $.derived(() => renderFormula($.get(tex), $.get(displayMode)));

	function renderFormula(source, display) {
		return katex.renderToString(source || "\\,", {
			displayMode: display,
			throwOnError: false,
			strict: "ignore",
			output: "htmlAndMathml"
		});
	}

	var div = root();

	$.html(div, () => $.get(rendered), true);
	$.reset(div);
	$.template_effect(() => $.set_attribute(div, 'data-display', $.get(displayMode) ? "block" : "inline"));
	$.append($$anchor, div);
	$.pop();
}